import usaStatesLib from 'usa-states';
import {
  CONSULT_TOPIC,
  CONSULT_TOPIC_UPP,
  INTERPRETER_LANGUAGES,
} from 'constants/consults';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const usStates = new usaStatesLib.UsaStates();
export const statesOptions = usStates.states.map(
  ({ abbreviation, name }: { abbreviation: string; name: string }) => ({
    label: name,
    value: abbreviation,
  }),
);

export const topicOptions = [
  {
    label: CONSULT_TOPIC.Foresight.label,
    value: CONSULT_TOPIC.Foresight.value,
  },
  {
    label: CONSULT_TOPIC.Prequel.label,
    value: CONSULT_TOPIC.Prequel.value,
  },
  {
    label: CONSULT_TOPIC.myRisk.label,
    value: CONSULT_TOPIC.myRisk.value,
  },
  {
    label: CONSULT_TOPIC.DonorRecipient.label,
    value: CONSULT_TOPIC.DonorRecipient.value,
  },
  {
    label: CONSULT_TOPIC.Reliant.label,
    value: CONSULT_TOPIC.Reliant.value,
  },
];

export const topicOptionsUPP = [
  {
    label: CONSULT_TOPIC_UPP.Foresight.label,
    value: CONSULT_TOPIC_UPP.Foresight.value,
  },
  {
    label: CONSULT_TOPIC_UPP.Prequel.label,
    value: CONSULT_TOPIC_UPP.Prequel.value,
  },
  {
    label: CONSULT_TOPIC_UPP.myRisk.label,
    value: CONSULT_TOPIC_UPP.myRisk.value,
  },
  {
    label: CONSULT_TOPIC_UPP.DonorRecipient.label,
    value: CONSULT_TOPIC_UPP.DonorRecipient.value,
  },
  {
    label: CONSULT_TOPIC_UPP.Reliant.label,
    value: CONSULT_TOPIC_UPP.Reliant.value,
  },
];

export const languagesOptions = INTERPRETER_LANGUAGES.map((item: string) => ({
  label: item,
  value: item,
}));
